// export const apiBaseUrl = "http://localhost:9090";
// export const apiBaseUrl = "https://ap-ranch-api.vercel.app";
// export const apiBaseUrl = "http://3.110.86.144:8080"
export const apiBaseUrl = "https://apranch.org/apr-server";
export const squareApplicationId = "sq0idp-ZoW4IK4rPRl9gM6zyID82A";
export const squareLocationId = "L8QRK1TAESYKK";

